export default __webpack_public_path__ + "src/assets/instagram.74114d67c8fe22e93cce4a73d88ee625.svg";